import * as React from 'react';
import {Box, Paragraph, Expand, Popover, Template} from '@pluto-tv/assemble';
import {GoogleLogout} from 'react-google-login';

import {SimpleAvatar} from 'components/simpleAvatar';

import {logout} from 'features/user/userSlice';

import {useAppDispatch} from 'app/store/hooks';

import {clientId} from '../../views/login/config/googleClientId';

interface IUserProps {
  avatar?: string;
  name: string;
  email: string;
  isExpanded: boolean;
}

export default ({avatar, name, email, isExpanded = false}: IUserProps): JSX.Element => {
  const dispatch = useAppDispatch();

  return (
    <Expand isExpanded={isExpanded} width='12.5rem'>
      <Template label='fixed'>
        <Popover>
          <Template label='trigger'>
            <SimpleAvatar name={name} src={avatar} sidebar={true}></SimpleAvatar>
          </Template>
          <Template label='popover'>
            <GoogleLogout
              clientId={clientId}
              buttonText='Logout'
              className='logout'
              onLogoutSuccess={() => dispatch(logout())}
              onFailure={() => dispatch(logout())}
            />
          </Template>
        </Popover>
      </Template>
      <Template label='expandable'>
        <Popover>
          <Template label='trigger'>
            <Box paddingTop='xsmall'>
              <Paragraph>{email}</Paragraph>
            </Box>
          </Template>
          <Template label='popover'>
            <GoogleLogout
              clientId={clientId}
              buttonText='Logout'
              className='logout'
              onLogoutSuccess={() => dispatch(logout())}
              onFailure={() => dispatch(logout())}
            />
          </Template>
        </Popover>
      </Template>
    </Expand>
  );
};
